var _defs, _namedview, _path, _path2, _path3, _path4, _path5, _clipPath, _rect, _rect2, _path6, _path7, _path8, _path9, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBrazilFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    space: "preserve",
    docname: "Brazilian_flag_icon_round.svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6474"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "band"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 0,
    cx: 0,
    r: 735,
    id: "circle7214"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gcut"
  }, /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m -31.5,0 v -70 h 63 V 0 Z M 0,-47 v 12 h 31.5 v -12 z",
    id: "path7169"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath11199"
  }, /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m -31.5,0 v -70 h 63 V 0 Z M 0,-47 v 12 h 31.5 v -12 z",
    id: "path11197"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "band-6"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 0,
    cx: 0,
    r: 735,
    id: "circle7214-7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gcut-4"
  }, /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m -31.5,0 v -70 h 63 V 0 Z M 0,-47 v 12 h 31.5 v -12 z",
    id: "path7169-1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath12554"
  }, /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m -31.5,0 v -70 h 63 V 0 Z M 0,-47 v 12 h 31.5 v -12 z",
    id: "path12552"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "band-3"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 0,
    cx: 0,
    r: 735,
    id: "circle7214-5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gcut-3"
  }, /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m -31.5,0 v -70 h 63 V 0 Z M 0,-47 v 12 h 31.5 v -12 z",
    id: "path7169-7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath14419"
  }, /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m -31.5,0 v -70 h 63 V 0 Z M 0,-47 v 12 h 31.5 v -12 z",
    id: "path14417"
  })))), _namedview || (_namedview = /*#__PURE__*/React.createElement("namedview", {
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    objecttolerance: 10,
    gridtolerance: 10,
    guidetolerance: 10,
    pageopacity: 0,
    pageshadow: 2,
    "window-width": 1920,
    "window-height": 1017,
    id: "namedview6472",
    showgrid: "false",
    zoom: 0.4609375,
    cx: -544.54238,
    cy: 256,
    "window-x": -8,
    "window-y": -8,
    "window-maximized": 1,
    "current-layer": "Layer_1"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#009b3a",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 389.50588989,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path17332",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6441",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6443",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6445",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6447",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6449",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6451",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6453",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6455",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6457",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6459",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6461",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6463",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6465",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6467",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g6469",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g16285",
    transform: "matrix(0.8103375,0,0,0.8103375,60.859741,43.279542)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      fill: "#009b3a",
      strokeWidth: 0.17142858
    },
    id: "rect7208",
    width: "17.142859%",
    height: "17.142859%",
    x: 240.81355,
    y: 262.50848
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fedf00",
      strokeWidth: 0.17142858
    },
    "connector-curvature": 0,
    id: "path7210",
    d: "m -57.986438,262.50847 298.799998,190.8 298.8,-190.8 -298.8,-190.799998 z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle7212",
    r: 126,
    cx: 240.81355,
    cy: 262.50848,
    style: {
      fill: "#002776",
      strokeWidth: 0.17142858
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(0.17142857,0,0,0.17142857,240.81356,262.50847)",
    id: "path7217",
    clipPath: "url(#band-6)",
    d: "m -2205,1470 a 1785,1785 0 0 1 3570,0 h -105 a 1680,1680 0 1 0 -3360,0 z",
    "connector-curvature": 0,
    style: {
      fill: "#ffffff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#009b3a"
    },
    id: "g7249",
    transform: "matrix(0.17142857,0,0,0.17142857,168.81356,514.50847)"
  }, /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m -206.87321,-1684.8471 a 35,31.5 83 0 0 -8.53085,-69.4782 35,31.5 83 0 0 8.53085,69.4782 m -1.5843,-12.9031 a 22,18.5 83 0 0 -5.36225,-43.672 22,18.5 83 0 0 5.36225,43.672",
    id: "use7219",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "use7221",
    transform: "rotate(-4,-24305.02,848.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd"
    },
    id: "path12789",
    d: "m -31.5,0 h 13 v -26 h 28 a 22,22 0 0 0 0,-44 h -40 z m 13,-39 h 27 a 9,9 0 0 0 0,-18 h -27 z",
    "connector-curvature": 0
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    id: "path12791",
    d: "m 28,0 c 0,-10 0,-32 -15,-32 H -6 c 22,0 22,22 22,32"
  }))), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m -61.120662,-1696.6917 32.994974,-0.5759 a 30,30 0 0 0 29.4718583,-30.519 l -0.1745241,-9.9985 a 30,30 0 0 0 -30.5190032,-29.4719 l -32.994974,0.5759 z m 12.771138,-13.2249 18.997107,-0.3316 a 19,19 0 0 0 18.66551,-19.3287 l -0.104714,-5.9991 a 19,19 0 0 0 -19.328702,-18.6655 l -18.997106,0.3316 z",
    id: "use7223",
    style: {
      fillRule: "evenodd"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 27.761085,-1697.5653 62.961622,2.1987 0.453693,-12.9921 -50.968932,-1.7798 0.628191,-17.9891 39.975633,1.396 0.418794,-11.9927 -39.975633,-1.396 0.488593,-13.9914 47.97076,1.6751 0.453693,-12.9921 -59.96345,-2.0939 z",
    id: "use7225"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 116.56674,-1693.7859 11.95434,1.0459 4.18347,-47.8174 9.76325,49.0375 10.95814,0.9588 18.13021,-46.5972 -4.18348,47.8173 11.95434,1.0459 6.1009,-69.7336 -17.43341,-1.5252 -18.1302,46.5971 -9.76325,-49.0375 -17.43341,-1.5252 z",
    id: "use7227"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 261.59994,-1677.4268 51.74169,8.8908 2.03219,-11.8267 -39.91502,-6.8586 2.7096,-15.7689 32.52334,5.5885 2.0322,-11.8266 -32.52335,-5.5886 1.86284,-10.8411 38.68308,6.647 2.03219,-11.8267 -50.50975,-8.6792 z",
    id: "use7229"
  })), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 394.52341,-1651.3176 12.58592,3.255 6.50988,-25.1719 27.10813,7.0107 a 22.000002,22.000002 0 0 0 11.01672,-42.5985 l -38.72591,-10.0152 z m 22.35074,-34.5028 26.13998,6.7603 a 9.0000206,9.0000206 0 0 0 4.50684,-17.4267 l -26.13998,-6.7603 z",
    id: "use7231",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "use7233",
    transform: "rotate(17.5,5514.4173,848.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd"
    },
    id: "path12795",
    d: "m -31.5,0 h 13 v -26 h 28 a 22,22 0 0 0 0,-44 h -40 z m 13,-39 h 27 a 9,9 0 0 0 0,-18 h -27 z",
    "connector-curvature": 0
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    id: "path12797",
    d: "m 28,0 c 0,-10 0,-32 -15,-32 H -6 c 22,0 22,22 22,32"
  }))), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 594.47703,-1590.001 a 31.50002,35.000022 20.5 0 0 24.51452,-65.5671 31.50002,35.000022 20.5 0 0 -24.51452,65.5671 m 4.5527,-12.1768 a 18.500009,22.00001 20.5 0 0 15.40912,-41.2136 18.500009,22.00001 20.5 0 0 -15.40912,41.2136",
    id: "use7235",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "use7237",
    transform: "rotate(23.5,4080.523,848.75)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath12779"
  }, /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    id: "path12777",
    d: "m -31.5,0 v -70 h 63 V 0 Z M 0,-47 v 12 h 31.5 v -12 z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd"
    },
    id: "path12781",
    d: "M 0,0 A 31.5,35 0 0 0 0,-70 31.5,35 0 0 0 0,0 m 0,-13 a 18.5,22 0 0 0 0,-44 18.5,22 0 0 0 0,44",
    "connector-curvature": 0
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "rect12783",
    width: 26.5,
    height: 10,
    x: 5,
    y: -35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "rect12785",
    width: 10,
    height: 35,
    x: 21.5,
    y: -35
  }))), /*#__PURE__*/React.createElement("g", {
    id: "use7239",
    transform: "rotate(26.5,3604.5124,848.75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd"
    },
    id: "path12801",
    d: "m -31.5,0 h 13 v -26 h 28 a 22,22 0 0 0 0,-44 h -40 z m 13,-39 h 27 a 9,9 0 0 0 0,-18 h -27 z",
    "connector-curvature": 0
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    id: "path12803",
    d: "m 28,0 c 0,-10 0,-32 -15,-32 H -6 c 22,0 22,22 22,32"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 808.47279,-1492.9401 54.83241,31.0226 6.4015,-11.3146 -44.38814,-25.1136 8.86363,-15.6664 34.81423,19.697 5.90908,-10.4443 -34.81423,-19.6969 6.89393,-12.185 41.77707,23.6363 6.40151,-11.3146 -52.22134,-29.5454 z",
    id: "use7241"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 910.60326,-1458.6741 c -3.7611,5.9038 0.0512,12.4824 8.48516,17.8554 8.43392,5.373 14.17782,5.1788 16.6041,1.3889 7.65652,-12.0183 -36.60773,-29.5466 -22.96439,-50.497 11.76279,-17.9986 31.88858,-3.9914 39.4791,0.8443 7.59053,4.8357 19.77898,17.3434 10.29972,31.7576 l -12.86172,-8.1939 c 4.02974,-6.3254 -0.39642,-12.4058 -7.14356,-16.7042 -6.53628,-4.1641 -11.84656,-6.065 -15.74198,0.05 -6.52412,9.7755 36.85766,28.2237 23.55949,49.0976 -9.80572,15.3919 -26.86731,8.6724 -38.25309,1.4188 -9.69901,-6.1789 -24.19116,-20.747 -14.74624,-35.4795 z",
    id: "use7243"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 985.69641,-1409.0177 c -4.06492,5.6988 -0.6021,12.468 7.53906,18.275 8.14113,5.807 13.88733,5.9137 16.50863,2.256 8.275,-11.6012 -35.01119,-31.422 -20.29009,-51.6297 12.68869,-17.3583 32.05379,-2.317 39.38079,2.9093 7.3271,5.2264 18.8442,18.3548 8.6236,32.2531 l -12.4153,-8.8557 c 4.3553,-6.1059 0.2534,-12.4096 -6.2595,-17.0553 -6.3094,-4.5004 -11.5129,-6.6766 -15.723,-0.7743 -7.02683,9.4207 35.33,30.114 20.9576,50.2633 -10.5978,14.8576 -27.28437,7.2544 -38.27493,-0.5851 -9.36233,-6.6781 -23.07218,-21.9847 -12.86918,-36.2027 z",
    id: "use7245"
  })), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 1056.7186,-1328.4773 a 31.500003,35.000004 38.5 0 0 43.576,-54.7826 31.500003,35.000004 38.5 0 0 -43.576,54.7826 m 8.0927,-10.174 a 18.5,22 38.5 0 0 27.3906,-34.4347 18.5,22 38.5 0 0 -27.3906,34.4347",
    id: "use7247",
    style: {
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.4,0,0,5.4,137.95642,239.8799)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B1CMi"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g13323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13319",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13321"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13325",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13327"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13335"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13331",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13333"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13341"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13337",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13339"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13343",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13345"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.4,0,0,5.4,149.09928,292.85133)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B1CMa"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "g13355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13351",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13353"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13357",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13359"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13363",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13365"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13369",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13371"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13375",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13377"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,133.6707,304.16561)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B2CMa"
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "g13035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13031",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13033"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13037",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13039"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13047"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13043",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13045"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13049",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13051"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13059"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13055",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13057"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5714286,0,0,2.5714286,161.44213,285.13704)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B3CMa"
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "g13803"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13799",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13801"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13809"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13805",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13807"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13811",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13813"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13821"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13817",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13819"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13827"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13823",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13825"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,175.32785,305.36561)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B4CMa"
  }, _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "g13067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13063",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13065"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13069",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13071"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13079"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13075",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13077"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13081",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13083"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13087",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13089"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,171.55642,317.8799)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B5CMa"
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "g13515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13511",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13513"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13517",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13519"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13523",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13525"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13529",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13531"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13535",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13537"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.4,0,0,5.4,279.89927,223.42276)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B1Vir"
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "g13387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13383",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13385"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13389",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13391"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13395",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13397"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13405"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13401",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13403"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13407",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13409"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.4,0,0,5.4,329.09927,306.73704)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B1Sco"
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "g13419"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13415",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13417"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13421",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13423"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13427",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13429"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13437"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13433",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13435"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13443"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13439",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13441"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,346.58499,307.93704)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B2Sco"
  }, _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "g13547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13543",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13545"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13549",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13551"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13555",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13557"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13561",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13563"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13567",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13569"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,334.24213,317.8799)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B5Sco"
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "g13099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13095",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13097"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13101",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13103"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13107",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13109"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13113",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13115"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13119",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13121"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,303.89927,344.2799)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B8Sco"
  }, _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "g13131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13127",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13129"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13137"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13133",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13135"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13143"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13139",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13141"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13149"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13145",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13147"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13151",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13153"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,303.72785,356.96561)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B9Sco"
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "g13579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13575",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13577"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13581",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13583"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13591"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13587",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13589"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13597"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13593",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13595"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13599",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13601"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,316.41356,334.33704)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03BASco"
  }, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "g13611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13607",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13609"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13617"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13613",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13615"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13619",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13621"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13629"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13625",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13627"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13631",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13633"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,326.52785,327.99418)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03BBSco"
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "g13163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13159",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13161"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13165",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13167"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13171",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13173"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13181"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13177",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13179"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13183",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13185"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,303.38499,331.93704)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03BCSco"
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "g13643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13639",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13641"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13645",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13647"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13651",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13653"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13661"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13657",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13659"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13663",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13665"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,192.81356,267.65133)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B1Hya"
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "g13195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13191",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13193"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13197",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13199"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13203",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13205"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13209",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13211"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13215",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13217"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,275.09927,256.16561)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B3Hya"
  }, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "g13675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13671",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13673"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13677",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13679"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13683",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13685"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13689",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13691"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13695",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13697"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.4,0,0,5.4,240.81356,319.0799)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B1Cru"
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "g13451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13447",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13449"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13457"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13453",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13455"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13459",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13461"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13469"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13465",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13467"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13471",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13473"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,255.38499,294.05133)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B2Cru"
  }, _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "g13227"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13223",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13225"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13229",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13231"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13239"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13235",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13237"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13241",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13243"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13251"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13247",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13249"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,240.81356,282.73704)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B3Cru"
  }, _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "g13259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13255",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13257"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13261",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13263"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13271"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13267",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13269"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13277"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13273",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13275"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13279",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13281"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,228.12785,294.05133)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B4Cru"
  }, _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "g13707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13703",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13705"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13709",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13711"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13715",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13717"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13721",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13723"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13731"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13727",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13729"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5714286,0,0,2.5714286,234.4707,302.79418)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B5Cru"
  }, _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "g13835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13831",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13833"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13837",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13839"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13843",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13845"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13853"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13849",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13851"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13855",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13857"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5,0,0,4.5,278.52785,347.36561)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B1TrA"
  }, _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "g13291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13287",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13289"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13293",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13295"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13299",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13301"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13309"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13305",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13307"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13311",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13313"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,289.32785,336.22276)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B2TrA"
  }, _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "g13739"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13735",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13737"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13741",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13743"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13751"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13747",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13749"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13753",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13755"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13759",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13761"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6,0,0,3.6,268.58499,333.13704)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B3TrA"
  }, _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "g13771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13767",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13769"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13773",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13775"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13779",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13781"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13785",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13787"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13791",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13793"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.4,0,0,5.4,190.24213,329.36561)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03B1Car"
  }, _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "g13483"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13479",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13481"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13489"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13485",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13487"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13491",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13493"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13497",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13499"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13503",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13505"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.8,0,0,1.8,240.81356,361.0799)",
    style: {
      fill: "#ffffff"
    },
    id: "\u03C3Oct"
  }, _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "g13867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13863",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13865"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(72)",
    id: "g13873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13869",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13871"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-72)",
    id: "g13879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13875",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13877"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(144)",
    id: "g13885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13881",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13883"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-144)",
    id: "g13891"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13887",
    transform: "rotate(18,0,-1)",
    d: "M 0,-1 V 0 H 0.5",
    "connector-curvature": 0
  }), /*#__PURE__*/React.createElement("path", {
    "connector-curvature": 0,
    d: "m 0,-1 0.30901699,0.95105652 -0.47552825,0.15450849",
    id: "path13889"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilFlag);
export default __webpack_public_path__ + "static/media/BrazilFlag.3f47fce1f784af429c26fca7b122109c.svg";
export { ForwardRef as ReactComponent };